import { cn } from "@/utils";
import React, { useLayoutEffect, useRef, useState } from "react";
import { FaChevronDown } from "react-icons/fa6";

interface ToggleTextProps {
  text: string;
  maxLines?: number;
  className?: string;
  showMoreText?: string;
  showLessText?: string;
}

export const ToggleText: React.FC<ToggleTextProps> = ({
  text,
  maxLines = 2,
  className = "",
  showMoreText = "もっと見る",
  showLessText = "折りたたむ",
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [shouldShowButton, setShouldShowButton] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const checkTextOverflow = () => {
      const element = textRef.current;
      if (element) {
        // Tạm thời remove line-clamp để đo chiều cao thực
        element.className = element.className.replace(/line-clamp-\d+/, "");
        const fullHeight = element.scrollHeight;

        // Áp dụng lại line-clamp
        element.className += ` line-clamp-${maxLines}`;
        const clampedHeight = element.clientHeight;
        // Nếu text bị cắt thì hiện button
        setShouldShowButton(fullHeight > clampedHeight);
      }
    };

    checkTextOverflow();

    // Thêm resize listener để check lại khi window resize
    window.addEventListener("resize", checkTextOverflow);
    return () => window.removeEventListener("resize", checkTextOverflow);
  }, [text, maxLines]);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      <div
        ref={textRef}
        className={cn(
          "text-light_secondary text-sm leading-5.5 whitespace-pre-line wrap-break-word",
          className,
          !isExpanded && `line-clamp-${maxLines}`
        )}
      >
        {text}
      </div>

      {shouldShowButton && (
        <button
          type="button"
          className="flex items-center gap-1 text-cyan mt-2 text-sm hover:underline"
          onClick={toggleExpand}
        >
          <span>{isExpanded ? showLessText : showMoreText}</span>
          <FaChevronDown
            className={cn(
              "transition-transform duration-300 size-3",
              isExpanded && "rotate-180"
            )}
          />
        </button>
      )}
    </div>
  );
};
